module.exports = __webpack_public_path__ + "assets/img/Vouchers1.c2fc563e.svg";